/**
 * Footer - Componente footer globale per tutte le pagine
 *
 * Design coerente con il tema Coronatek:
 * - Sfondo scuro con gradiente
 * - Layout centrato max 1400px
 * - Responsive
 */

import React from 'react';
import { getVersionString } from '../../../version';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 border-t border-slate-700 mt-auto">
      {/* Container centrato come il resto del contenuto */}
      <div
        className="px-4 sm:px-6 lg:px-8 py-6"
        style={{
          width: '100%',
          maxWidth: '1400px',
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >
        {/* Grid responsive: 1 colonna mobile, 3 colonne desktop */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* Colonna 1: Info azienda */}
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">TurboManager</h3>
            <p className="text-slate-400 text-sm">
              Sistema di gestione turbine dalla presa in carico alla riconsegna
            </p>
          </div>

          {/* Colonna 2: Links */}
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">Links</h3>
            <ul className="space-y-2 text-slate-400 text-sm">
              {/* Links da aggiungere in futuro */}
            </ul>
          </div>

          {/* Colonna 3: Info tecnico */}
          <div className="space-y-3">
            <h3 className="text-lg font-semibold text-white">Informazioni</h3>
            <p className="text-slate-400 text-sm">
              Versione: {getVersionString()}
            </p>
            <p className="text-slate-400 text-sm">
              © {currentYear} Dialogicom s.r.l.s.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-slate-700 mt-8 pt-6">
          <p className="text-center text-slate-500 text-sm">
            Sviluppato con ❤️ da Dialogicom
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
